import React, { Component } from 'react'
import { PageHeader, Input, Row, Col, Button, Tooltip, Tabs } from 'antd'
import { withRouter } from 'react-router-dom'
import { PlusOutlined, SaveOutlined, UndoOutlined, FileOutlined, CodeOutlined } from '@ant-design/icons';
import Axios from '../../../config/axios'
import '../../../style.css'
import './style.css'
import withErrorHandler from '../../../hoc/withErrorHandler'
import Loading from '../../../components/Loading';
import TextArea from 'antd/lib/input/TextArea';

const pretty = require('pretty')

class AddLeaflet extends Component {

    state = {
        letterID : "",
        letter : {
            title : "",
            type : "",
            fields : [],            
            template: '', 
            letterhead: ''           
        },
        form: {
            title : "",
            type : "",
            fields : [],            
            template: '',
            letterhead: ''            
        },        
        errors: {}
    }

    componentDidMount() {
        if(this.props.match.params.id){
            this.setState({ letterID : this.props.match.params.id}, () => this.fetchLetter())            
        }
    }
    
    fetchLetter = () => {
        Axios.get("/leaflets/"+this.state.letterID).then(response => {
            const letter = {...response.data}                             
            this.setState({ letter, form: response.data })
        })
    }

    resetForm = () => {        
        const form = {...this.state.letter}
        this.setState({ form, errors : {} })
    }

    handleAddField = () => {
        const { form } = this.state
        form.fields = [...form.fields, {
            name : '',
            placeholder : '',
            label : ''
        }]
        this.setState({ form })
    }

    handleChangeForm = (e) => {        
        let { form } = this.state
        form[e.target.name] = e.target.value
        this.setState({ form, errors : {} })
    }
    
    handleChangeField = (e) => {        
        let { form } = this.state
        let fields = form.fields  
        const key = e.target.name.split("-")
        fields[key[1]][key[0]] = e.target.value           
        this.setState({ form, errors : {} })
    }

    handleSubmit = () => {
        const { form } = this.state        
        delete form._id        
        Axios.request({
            method: this.state.letterID ? 'PUT' : 'POST',
            url : "/leaflets/save"+ (this.state.letterID ? "/"+this.state.letterID : ''),
            data: form            
        }).then(() => {
            this.props.history.push({
                pathname : '/admin/master-surat',
                state : {
                    message : this.state.letterID ? "Sura Berhasil Diubah" : "Surat Berhasil Ditambah",
                    type: 'success',
                    tabKey: '2'
                }
            })
        }).catch(errors => {
            this.setState({ errors : errors.data })            
        })
    }

    handlePretty = () => {        
        let { form } = this.state
        form.template = pretty(form.template)
        this.setState({ form })
    }

    render() {        
        const { form } = this.state           
        return(
            <>
                <div className="site-layout-background" style={{ padding: 10 }}>
                    <PageHeader
                        className="site-page-header"
                        onBack={() => this.props.history.push({
                            pathname : '/admin/master-surat',
                            state: {
                                tabKey: '2'
                            }
                        })}                        
                        title="Master Surat"
                        subTitle="kelola surat Edaran"
                        extra={[
                            <Button key="reset" onClick={this.resetForm}><UndoOutlined /> Reset</Button>,
                            <Button key="save" type="primary" onClick={this.handleSubmit}><SaveOutlined /> <span>Simpan</span></Button>
                        ]}
                    />                  
                </div>
                
                <Row style={{padding:10}}>                    
                    <Col sm={24} md={24} lg={7}>
                        <Col className="card-form mt-10">
                            <h3>Keterangan</h3>
                            <label>Nama Surat</label>
                            <Input
                                placeholder="Nama Surat"
                                value={form.title}
                                onChange={this.handleChangeForm}
                                name="title"
                            />
                            {<span className="error-message">{this.state.errors.title}</span>}                         
                        </Col>

                        <Col className="card-form mt-10">  
                            <Row> 
                            <Col><h3>Fields</h3> </Col>                                                                  
                            <Col style={{position:'absolute', right:20}}>
                                <Tooltip title="Tambah Field">
                                    <Button 
                                        shape="circle" 
                                        className="add-button"
                                        onClick={this.handleAddField}
                                    >
                                        <PlusOutlined />
                                    </Button>
                                </Tooltip>
                            </Col>
                            </Row>
                            <Row className="mt-10">
                            {
                                form.fields.map((field, index) => 
                                    <Col className="mb-10" key={index}>
                                        <div>
                                        <label>Label</label>
                                        <Input
                                            className="mb-5"
                                            name={"label-"+index}
                                            placeholder="label"
                                            value={field.label}
                                            onChange={this.handleChangeField}
                                        />
                                        {<span className="error-message">{this.state.errors["fields."+index+".label"]}</span>}
                                        </div>
                                        <div>
                                        <label>Placeholder</label>
                                        <Input
                                            className="mb-5"
                                            name={"placeholder-"+index}
                                            placeholder="placeholder"
                                            value={field.placeholder}
                                            onChange={this.handleChangeField}
                                        />
                                        {<span className="error-message">{this.state.errors["fields."+index+".placeholder"]}</span>}
                                        </div>
                                        <div>
                                        <label>Name</label>
                                        <Input
                                            className="mb-5"
                                            name={"name-"+index}
                                            placeholder="name"
                                            value={field.name}
                                            onChange={this.handleChangeField}
                                        />
                                        {<span className="error-message">{this.state.errors["fields."+index+".name"]}</span>}
                                        </div>
                                    </Col>    
                                )
                            }
                            </Row>                            
                        </Col>                                            
                    </Col>    
                    
                      <Col>                           
                          <Col className="style-3 right">                          
                            <div className="card-form mt-10">
                                <h3>Template</h3>
                                <p>
                                    Gunakan {"{{name}}"} untuk setiap variabel sesuai dengan field yang telah diinput. <br />
                                    Contoh: Nama saya {"{{name}}"}, saya berumur {"{{usia}}"}
                                </p>                                
                              
                                <div style={{ overflowX:'auto'}} className="style-3">
                                <Tabs defaultActiveKey="1" style={{width:'212mm'}}>
                                    <Tabs.TabPane
                                        tab={
                                            <span>
                                                <FileOutlined />
                                                Overview
                                            </span>
                                        }
                                        key="1"
                                        style={{overflowY:'auto'}}  
                                        className="style-3"                                      
                                    >                                               
                                        
                                        <div>                               
                                            <div style={{height:500}}>                                      
                                                <div className="overview" dangerouslySetInnerHTML={{__html: this.state.form.template}}>
                                            </div>
                                        </div>
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane
                                        tab={
                                            <span><CodeOutlined /> Code</span>
                                        }
                                        key="2"                                        
                                    >
                                        <Col>      
                                        <Button style={{margin:5}} onClick={this.handlePretty}>Pretty</Button>                                         
                                            <TextArea
                                                className="style-3"
                                                value={this.state.form.template}
                                                name="template"
                                                rows={25}
                                                onChange={this.handleChangeForm}
                                            />
                                        </Col>     
                                    </Tabs.TabPane>
                                </Tabs>     
                                </div>                                   
                            </div>
                            </Col>                                                                             
                    </Col>                                        
                </Row>                
                <Loading loading={this.props.loading} />                 
            </>
        )
    }
}

export default withRouter(withErrorHandler(AddLeaflet, Axios))